<template lang="pug">
  v-dialog.grey(v-model="dialog" max-width="400" scrollable)
    template(v-slot:activator="{ on }")
      v-divider
      v-btn.my-4(v-on="on" text)
        v-icon.mr-4 mdi-lock
        span.text-capitalize {{ translations.title }}
    v-card
      v-card-title.d-flex.flex-nowrap.justify-space-between.headline.text-center(primary-title)
        span {{ translations.title }}
        v-btn(@click="dialog = false" icon)
          v-icon mdi-close
      v-card-text.fantasy__scrollbar.px-2.px-sm-6
        ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
          v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitChangePassword)")
            v-container(fluid)
              v-row
                v-col(cols="12")
                  BasePasswordField(rules="required" v-model="form.oldpassword", :label="translations.label.oldpassword")
                v-col(cols="12")
                  BasePasswordField(rules="required" v-model="form.password", :label="translations.label.password", :showProgress="true")
                v-col(cols="12")
                  BasePasswordField(rules="required" v-model="form.repeatpassword", :label="translations.label.repeatpassword", :confirm="form.password")
                v-col.pa-2.pa-md-6.text-right(cols="12")
                  v-btn.float-right.big(:disabled="invalid"
                    color="primary"
                    type="submit"
                    :loading="loadingChangePassword") {{ translations.button }}
</template>

<script>
  export default {
    name: "ChangePasswordDialog",
    props: {
      user: {
        type: Object,
        default: function(){
          return {}
        }
      }
    },
    data:() => ({
      dialog: false,
      form: {
        oldpassword: '',
        password: '',
        repeatpassword: '',
      },
    }),
    computed: {
      translations() {
        return this.$t("components.ChangePasswordDialog");
      },
      loadingChangePassword() {
        return this.$store.state.statusCode.changePassword.loading;
      },
      stateChangePassword() {
        return this.$store.state.statusCode.changePassword.state;
      },
    },
    watch: {
      dialog: function(val){
        if(val) {
          this.clear();
          if(this.$refs.validator) {
            this.$refs.validator.reset();
          }
        }
      },
      stateChangePassword: function(val){
        if (val == 200 && this.dialog){
          this.dialog = false;
          this.$emit('successChangePassword');
        }
      },
    },
    methods:{
      submitChangePassword(){
        const passwordDataSend = {
          _id: this.user.id,
          data: {
            pwd: this.form.oldpassword,
            newpwd: this.form.password,
          },
        };
        this.$store.dispatch('changePassword', passwordDataSend);
      },
      clear(){
        this.form.oldpassword = '';
        this.form.password = '';
        this.form.repeatpassword = '';
      },
    }
  }
</script>

<style lang="sass">
</style>